import { useState } from "react";

import { Input, DefaultTooltip, InputGroup, InputGroupText } from "twyne-new.ui";

import { useCraftProp } from "../utils";

export default function ProgressRangeProperty() {
  const { value: start, setValue: setStart } = useCraftProp('range.start')
  const { value: end, setValue: setEnd } = useCraftProp('range.end')

  const [startValue, setStartValue] = useState(null)
  const [endValue, setEndValue] = useState(null)

  const handleStart = start => {
    const maxValue = end || 100
    setStartValue(start)
    setStart(start >= maxValue ? maxValue - 1 : start < 0 ? 0 : start)
  }

  const handleEnd = end => {
    const minValue = start || 0
    setEndValue(end)
    setEnd(end <= minValue ? minValue + 1 : end > 100 ? 100 : end)
  }

  return <>
    <div className='flex items-center justify-between gap-1'>
      <InputGroup className="flex-1">
        <DefaultTooltip content='Progress bar start value.'>
          <InputGroupText>
            Start
          </InputGroupText>
        </DefaultTooltip>
        <Input
          value={startValue || start || 0}
          onChange={e => handleStart(Number(e.target.value))}
          onBlur={() => setStartValue(null)}
          type="number"
          variant='accent'
        />
      </InputGroup>

      <InputGroup className="flex-1">
        <DefaultTooltip content='Progress bar end value.'>
          <InputGroupText>
            End
          </InputGroupText>
        </DefaultTooltip>
        <Input
          value={endValue || end || 100}
          onChange={e => handleEnd(Number(e.target.value))}
          onBlur={() => setEndValue(null)}
          type="number"
          variant='accent'
        />
      </InputGroup>
    </div>
  </>
}
